import React from 'react';

type PushPanelShellProps = {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

const PushPanelShell: React.FC<PushPanelShellProps> = ({ title, description, actions, children }) => {
  const showHeader = Boolean(title || description || actions);
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      {showHeader ? (
        <div className="shrink-0 border-b border-gray-200 bg-white px-4 py-4 dark:border-gray-700 dark:bg-gray-900 sm:px-6">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0">
              {title ? (
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
              ) : null}
              {description ? <p className="mt-1 text-sm text-gray-500">{description}</p> : null}
            </div>
            {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
          </div>
        </div>
      ) : null}
      <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-6">{children}</div>
    </div>
  );
};

export default PushPanelShell;
